<template>
  <div class="app">
    <div class="sidebar-container" :class="{ 'sidebar-hidden': !isSidebarVisible }">
      <Sidebar />
    </div>
    <ChatMain @toggleSidebar="toggleSidebar" />
  </div>
</template>
<script setup lang="ts">
import Sidebar from './components/Sidebar.vue'
import ChatMain from './components/ChatMain.vue'
import {onMounted, ref} from "vue";
import useUserStore from "@/stores/user.ts";
import {ElMessage} from "element-plus";
import {useChatStore} from "@/stores/chat.ts";
const isSidebarVisible = ref(true)
const userStore = useUserStore()
const chatStore = useChatStore()
// 检查登录状态是否过期（24小时）
function checkLoginExpiration() {
  const loginTimestamp = localStorage.getItem('AISAFETY_LOGIN_TIMESTAMP')

  if (!loginTimestamp) {
    // 如果没有登录时间戳，说明是旧版本登录或已清除，不需要处理
    return
  }

  const loginTime = parseInt(loginTimestamp)
  const currentTime = new Date().getTime()
  const hoursPassed = (currentTime - loginTime) / (1000 * 60 * 60)

  // 如果超过24小时，清除登录状态
  if (hoursPassed > 24) {
    console.log(`登录已过期，已过${hoursPassed.toFixed(2)}小时`)

    // 先清空对话列表
    chatStore.clearAllConversations()
    userStore.$reset()
    userStore.setLoggedInState(false)
    localStorage.removeItem('AISAFETY_LOGIN_TIMESTAMP')

    // 显示提示消息
    ElMessage.warning('登录已过期，请重新登录')

    // 延迟刷新页面以确保所有状态都被重置
    setTimeout(() => {
      location.reload()
    }, 1500)
  } else {
    console.log(`登录有效，已过${hoursPassed.toFixed(2)}小时`)
  }
}

// 应用启动时检查登录状态
onMounted(() => {
  checkLoginExpiration()
})
function toggleSidebar() {
  isSidebarVisible.value = !isSidebarVisible.value
}
</script>
<style>
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.app {
  display: flex;
  height: 100vh;
  background: #fff;
}
.sidebar-container {
  transition: width 0.3s ease;
}

.sidebar-container.sidebar-hidden {
  width: 0 !important;
  overflow: hidden;
}

/* Element Plus overrides */
.el-input__wrapper {
  background-color: transparent !important;
}
</style>
